import { cloneDeep } from 'lodash'

const DEFAULT_STATE = {
  mode: 'basic',
  basic: {},
  advanced: ''
}

export const filtersReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'SWITCH_MODE': {
      return {
        ...state,
        mode: action.request.mode
      }
    }
    case 'SET_ADVANCED_VALUE': {
      return {
        ...state,
        advanced: action.request.value
      }
    }
    case 'SET_BASIC_VALUE': {
      return {
        ...state,
        basic: action.request.value
      }
    }
    case 'CHANGE_BASIC_VALUE': {
      const basic = { ...state.basic, ...action.request.value }

      return {
        ...state,
        basic: Object.fromEntries(Object.entries(basic).filter(([_, value]) => null !== value))
      }
    }
    case 'UPDATE_CASCADE_BASIC_VALUE': {
      const result = {
        ...state,
        basic: {
          ...state.basic,
          [action.request.key]: {
            ...(state.basic[action.request.key] || {}),
            ...action.request.value[action.request.key]
          }
        }
      }
      if (action.request.subkey[1]) {
        const level = Number(action.request.subkey[1])
        Object.keys(result.basic[action.request.key]).forEach(subkey => {
          if (Number(subkey[1]) > level) {
            delete result.basic[action.request.key][subkey]
          }
        })
      }
      return result
    }

    case 'DELETE_CASCADE_BASIC_VALUE': {
      const basic = cloneDeep(state.basic)
      if (basic[action.request.key] && basic[action.request.key][action.request.subkey])
        delete basic[action.request.key][action.request.subkey]
      const level = Number(action.request.subkey[1])
      Object.keys(basic[action.request.key] || {}).forEach(subkey => {
        if (Number(subkey[1]) > level) {
          delete basic[action.request.key][subkey]
        }
      })
      return {
        ...state,
        basic
      }
    }

    case 'DELETE_BASIC_VALUE': {
      const basic = { ...state.basic }

      const keys = Array.isArray(action.request.keys) ? action.request.keys : [action.request.keys]
      for (const key of keys) delete basic[key.toUpperCase()]

      return {
        ...state,
        basic
      }
    }
    case 'RESET_FILTERS': {
      return {
        ...state,
        basic: {}
      }
    }
    default:
      return state
  }
}
